import { useEffect } from "react";

export function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | Operandi Studio` : "Operandi Studio";
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
}
